export default __webpack_public_path__ + "8a0dc2c64be971c18e6d7eb050c5578c.svg";